<template>
  <button type="button" class="transform-tool-button" :class="{ active: expanded }" :disabled="disabled"
    :title="$t('editor.transformTools')" :aria-label="$t('editor.transformTools')"
    :aria-expanded="expanded" @click.stop="$emit('open')">
    <svg width="30" height="30" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.8">
      <path d="M8 8L25 11L22 25L7 23Z" />
      <rect x="5" y="5" width="5" height="5" fill="white" />
      <rect x="23" y="8" width="5" height="5" fill="white" />
      <rect x="20" y="23" width="5" height="5" fill="white" />
      <rect x="4" y="21" width="5" height="5" fill="white" />
    </svg>
  </button>
</template>
<script>
export default {
  props: { disabled: Boolean, expanded: Boolean },
  emits: ['open']
};
</script>
<style scoped>
.transform-tool-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  background: transparent;
  border-radius: 8px;
  color: #26374e;
  cursor: pointer;
  flex-shrink: 0;
  touch-action: manipulation;
}
.transform-tool-button.active { background: #e8f0fc; color: #55768f; }
.transform-tool-button:disabled { opacity: 0.45; cursor: not-allowed; }
.transform-tool-button:focus-visible { outline: 2px solid #55768f; }
</style>